import firebase from "firebase/app";
import "firebase/firestore";

const db = firebase.firestore();
export const getNewsletterEmails =
  (lastDoc = null, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let query = db
        .collection("newsletter")
        .orderBy("subscribedAt", "desc")
        .limit(5);

      if (lastDoc) {
        query = query.startAfter(lastDoc);
      }

      const querySnapshot = await query.get();

      const emails = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const formattedEmails = emails.map((email) => ({
        ...email,
        subscribedAt:
          email.subscribedAt instanceof firebase.firestore.Timestamp
            ? email.subscribedAt.toDate().toLocaleDateString()
            : email.subscribedAt,
      }));

      const newLastDoc =
        querySnapshot.docs[querySnapshot.docs.length - 1] || null;
      dispatch({
        type:
          lastDoc !== ""
            ? "ADD_MORE_NEWSLETTER_EMAILS"
            : "SET_NEWSLETTER_EMAILS",
        payload: {
          formattedEmails,
          lastDoc: newLastDoc,
          hasMore: emails.length === 5,
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      onComplete();
    }
  };
